import type { Colors, DefaultTheme } from 'styled-components';
import { darkColors, mapDarkTheme } from './DarkTheme';

const colors: Colors = {
  ...darkColors,
  primary: {
    lighten: '#87a9ff',
    default: '#5484ff',
    dim: 'rgba(84,132,255,0.4)',
    mute: 'rgba(84,132,255,0.1)',
  },
  gray: {
    '100': '#ffe',
    '000': '#030304',
    '010': '#0a0a0b',
    main: '#181A22',
    '020': '#25272e',
    '030': '#33353a',
    '040': '#414346',
    '050': '#484a4c',
    '060': '#515355',
    '070': '#616363',
    '080': '#8b8c88',
    '090': '#abaca4',
  },
  green: {
    lighten: '#48d176',
    default: '#2eb85c',
    dim: 'rgba(46,184,92,0.4)',
    mute: 'rgba(46,184,92,0.1)',
  },
  red: {
    lighten: '#f3817f',
    default: '#ef5350',
    dim: 'rgba(239,83,80,0.4)',
    mute: 'rgba(239,83,80,0.1)',
  },
  yellow: {
    lighten: '#ffc783',
    default: '#ffb050',
    dim: 'rgba(255,176,80,0.4)',
    mute: 'rgba(255,176,80,0.1)',
  },
  orange: {
    lighten: '#ffad33',
    default: '#ff9800',
    dim: 'rgba(255,152,0,0.4)',
    mute: 'rgba(255,152,0,0.1)',
  },
  blue: {
    lighten: '#61a8f0',
    default: '#338EEB',
    dim: 'rgba(51,142,235,0.4)',
    mute: 'rgba(51,142,235,0.1)',
  },
  purple: {
    lighten: '#a778e2',
    default: '#8B4ED9',
  },
  white: {
    default: '#ffffff',
    dim: 'rgba(255,255,255,0.4)',
    mute: 'rgba(255,255,255,0.1)',
  },
  black: {
    default: '#000000',
    dim: 'rgba(0,0,0,0.4)',
    mute: 'rgba(0,0,0,0.1)',
  },
};

export const DarkCoinhakoTheme: DefaultTheme = mapDarkTheme(colors, {
  name: 'DarkCh',

  colorTextDefaultButton: '#ffffff',
  colorTextDefaultButtonHover: '#ffffff',
  colorTextDefaultButtonFocus: '#ffffff',
  colorTextDefaultButtonActive: '#ffffff',
  colorTextDefaultButtonDisabled: 'rgba(255,255,255,0.5)',

  colorTextPositiveButton: '#000000',
  colorTextPositiveButtonHover: '#000000',
  colorTextPositiveButtonFocus: '#000000',
  colorTextPositiveButtonActive: '#000000',
  colorTextPositiveButtonDisabled: 'rgba(0,0,0,0.5)',

  colorTextNegativeButton: '#000000',
  colorTextNegativeButtonHover: '#000000',
  colorTextNegativeButtonFocus: '#000000',
  colorTextNegativeButtonActive: '#000000',
  colorTextNegativeButtonDisabled: 'rgba(0,0,0,0.5)',

  colorTextWarningButton: '#000000',
  colorTextWarningButtonHover: '#000000',
  colorTextWarningButtonFocus: '#000000',
  colorTextWarningButtonActive: '#000000',
  colorTextWarningButtonDisabled: 'rgba(0,0,0,0.5)',

  colorTextPrimaryButton: '#000000',
  colorTextPrimaryButtonHover: '#000000',
  colorTextPrimaryButtonFocus: '#000000',
  colorTextPrimaryButtonActive: '#000000',
  colorTextPrimaryButtonDisabled: 'rgba(0,0,0,0.5)',

  colorTextMutedButton: '#ffffff',
  colorTextMutedButtonHover: '#ffffff',
  colorTextMutedButtonFocus: '#ffffff',
  colorTextMutedButtonActive: '#ffffff',
  colorTextMutedButtonDisabled: 'rgba(255,255,255,0.5)',
});
